function affiliate_Reducer(state = [], action) {
    switch (action.type) {
        case 'AFFILIATE/SET':
            return action.affiliate;
        case 'AFFILIATE/CLEAR':
            return null;
        default:
            return state;
    }
}

export default affiliate_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/affiliate.js